<!-- Translated -->
<template>
  <article class="rightzone">
    <div class="rightzone_top">
      <Breadcrumps :data="[{ title: $t('GlossaryBadObjects:Title') }]" />

      <div class="rightzone_top-buttonswrap">
        <Button
          v-if="isShowAddButton"
          :text="$t('GlossaryBadObjects:ButtonAdd')"
          size="standart"
          color="accent"
          icon="plus"
          :is-loading="false"
          :loading-left="false"
          @click="$router.push({ name: 'NewPest' })"
        />
      </div>
    </div>

    <!--Фильтр-->
    <div class="cwrap cwrap--level1 marginbottom--standart">
      <div class="cblock el--borders-all el--rounded-all">
        <FilterGlossaryBadObjects
          v-model="filter"
          :categoriesPests="data.categoriesPests"
        />
      </div>
    </div>

    <!--(Табл)--->
    <div class="cwrap cwrap--level1 marginbottom--standart">
      <!--Таблица-->
      <div class="cblock">
        <Table
          :headers="tableHeaders"
          :data-arr="dataArr"
          :table-loading="request.isLoading"
          :loading-count-items="10"
          @editClick="onEditClick"
        />
        <!-- <img src="https://i.imgur.com/PdTu2pb.png" width="100%" /> -->
      </div>
    </div>
  </article>
</template>

<script>
import Button from '@/components/views/Button';
import Breadcrumps from '@/components/views/Breadcrumps';
import FilterGlossaryBadObjects from '@/components/filtres/FilterGlossaryBadObjects';
import glossaryApi from '@/api/glossary';
import Table from '@/components/tables/Table';
import routeNames from '@/router/routeNames';
import { mapState } from 'vuex';
import { mutationTypes } from '@/store/modules/filtersState';

export default {
  name: 'GlossaryBadObjects',
  components: {
    FilterGlossaryBadObjects,
    Breadcrumps,
    Button,
    Table,
  },
  data() {
    return {
      request: {
        isLoading: false,
        hasError: false,
      },
      data: {
        pests: [],
        images: [],
        categoriesPests: [],
      },
      metaData: {
        categoriesPestsMapById: new Map(),
        imagesMapByPestId: new Map(),
      },
      filter: {
        name: '',
        category_id: null,
      },
    };
  },
  methods: {
    prepareMetaData() {
      this.data.categoriesPests =
        this.$store.state.glossaryPests.categoriesPests;
      this.data.categoriesPests.forEach((val) => {
        this.metaData.categoriesPestsMapById.set(val.id, val);
      });
      this.metaData.imagesMapByPestId = new Map();
      this.data.pests?.forEach((val) => {
        this.metaData.imagesMapByPestId.set(val.id, []);
      });
      this.data.images?.forEach((val) => {
        if (!this.metaData.imagesMapByPestId.has(val?.object_id)) {
          this.metaData.imagesMapByPestId.set(val?.object_id, []);
        }
        this.metaData.imagesMapByPestId.get(val?.object_id)?.push(val);
      });
    },
    onEditClick(pestId) {
      this.$router.push({
        name: routeNames.editPest,
        params: { id: pestId },
      });
    },
    getNameOfCategoryByCategoryId(id) {
      return this.metaData.categoriesPestsMapById?.get(id)?.name || '';
    },
  },
  computed: {
    /*filter: {
      get() {
        return this.$store.state.filtersState.filterBadObjects;
      },
      set(payload) {
        this.$store.commit(mutationTypes.setFilterBadObjects, payload);
      },
    },*/
    ...mapState({
      canEdit: (state) => state.auth.currentUserRole?.claim_glossary_edit === 1,
    }),
    tableHeaders() {
      return [
        {
          text: this.$t('GlossaryBadObjects:TableHeaders:0'), //'Название',
          class: 'col--accent',
          width: '30%',
          type: 'text',
        },
        {
          text: this.$t('GlossaryBadObjects:TableHeaders:1'), //'Категория',
          width: '20%',
          type: 'text',
        },
        {
          text: this.$t('GlossaryBadObjects:TableHeaders:2'), //'Описание',
          width: '35%',
          type: 'text',
        },
        {
          text: this.$t('GlossaryBadObjects:TableHeaders:3'), //'Фото',
          width: '15%',
          class: 'col--center',
          type: 'image',
        },
        {
          text: this.$t('GlossaryBadObjects:TableHeaders:4'), //'Ссылка',
          class: 'col-link',
          type: 'link',
        },
        // {
        //   text: this.$t('GlossaryBadObjects:TableHeaders:5'), //'Статус',
        //   class: 'col-status',
        //   type: 'status',
        // },
        {
          text: '',
          class: 'col-edit',
          width: '',
          type: 'edit',
          icon: this.canEdit ? 'edit' : 'passwordshow',
        },
      ];
    },
    dataArr() {
      let arr = [];

      this.data.pests?.forEach((pest) => {
        let tr = [];
        tr.push({ text: pest.name || '' });
        tr.push({
          text: this.getNameOfCategoryByCategoryId(pest?.category_id) || '',
        });
        tr.push({
          text: pest.description || '',
        });
        tr.push({ images: this.metaData.imagesMapByPestId.get(pest.id) });
        tr.push({ text: pest.link || '' });
        // tr.push({ text: pest.is_active === 1 ? 'on' : 'off' });
        tr.push({ text: pest.id });

        let filterIsActive = false;
        for (let filterKey in this.filter) {
          if (this.filter[filterKey]) {
            filterIsActive = true;
            break;
          }
        }
        if (filterIsActive) {
          let filerRes = true;

          if (this.filter.name !== '') {
            if (
              !(pest.name || '')
                .toLowerCase()
                .includes(this.filter.name.toLowerCase())
            ) {
              filerRes = false;
            }
          }
          if (this.filter.category_id !== null) {
            if (pest?.category_id !== this.filter.category_id) {
              filerRes = false;
            }
          }
          if (filerRes) {
            arr.push(tr);
          }
        } else {
          arr.push(tr);
        }

        //arr.push(tr);
      });
      return arr;
    },
    isShowAddButton() {
      return (
        this.$store.state.auth?.currentUserRole?.claim_glossary_edit || false
      );
    },
  },
  watch: {
    filter: {
      handler(val) {
        this.$store.commit(mutationTypes.setFilterBadObjects, { ...val });
      },
      deep: true,
    },
  },
  async created() {
    try {
      for (let filterKey in this.filter) {
        this.filter[filterKey] =
          this.$store.state.filtersState.filterBadObjects[filterKey];
      }
      this.request.isLoading = true;
      let response = await glossaryApi.getPests();
      if (response.data.status === 'ok') {
        this.request.hasError = false;
        Object.keys(response.data).forEach((key) => {
          if (
            Object.keys(this.data).includes(key) &&
            response.data[key] instanceof Array
          ) {
            this.data[key] = response.data[key];
          }
        });
        this.prepareMetaData();
      } else {
        this.request.hasError = true;
      }
      this.request.isLoading = false;
    } catch (e) {
      this.request.hasError = true;
      this.request.isLoading = false;
      console.log(e);
    }
  },
};
</script>

<style lang="scss" scoped></style>
